import { render, staticRenderFns } from "./SelectWarehouseSelfPickUp.vue?vue&type=template&id=6b238e93&"
import script from "./SelectWarehouseSelfPickUp.vue?vue&type=script&lang=js&"
export * from "./SelectWarehouseSelfPickUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports